import { List } from '@mantine/core'
import ListClasses from './styles.module.css'
import '../../styles/variables.css'
export default List.extend({
    defaultProps: {
        fw: 'var(--gm-weight-label)',
        color: 'var(--gm-foreground-fg-primary)',
        fs: 'var(--gm-label-m-font-size)',
        lh: 'var(--gm-label-s-line-height)',
    },
    classNames: ListClasses,
})
